import { useEffect, useState } from "react";

export function useSecondClickConfirm(timeoutMs = 3000) {
  const [pendingId, setPendingId] = useState("");

  useEffect(() => {
    if (!pendingId) {
      return;
    }
    const timeout = window.setTimeout(() => setPendingId(""), timeoutMs);
    return () => window.clearTimeout(timeout);
  }, [pendingId, timeoutMs]);

  const request = (id: string, onConfirm: () => void) => {
    if (pendingId === id) {
      setPendingId("");
      onConfirm();
      return;
    }
    setPendingId(id);
  };

  return { pendingId, request, reset: () => setPendingId("") };
}
